import { NavigationHashEnum } from 'core/type/Details.types';
import React from 'react';
import { DetailContentOnToggleProps } from 'component/page/deprecatedDetail/DetailPageContent/DetailPageContent.selectors';
import ActivityOverview from 'component/page/deprecatedDetail/DetailCard/Overview/ActivityOverview';
import PackageOptionsWrapper from 'component/page/detail/PackageOptions/PackageOptionsWrapper';
import SimCardSpecification from 'component/page/detail/MoreInfoSections/SimCardSpecification/SimCardSpecification';
import IntroductionSummary from 'component/page/detail/MoreInfoSections/IntroductionSummary/IntroductionSummary';
import DepartureAndReturn from 'component/page/detail/MoreInfoSections/DepartureAndReturn/DepartureAndReturn';
import WhatToExpect from 'component/page/detail/MoreInfoSections/WhatToExpect/WhatToExpect';
import Location from 'component/page/detail/MoreInfoSections/Location/Location';
import SuggestedRoute from 'component/page/detail/MoreInfoSections/SuggestedRoute/SuggestedRoute';
import AdditionalInformation from 'component/page/detail/MoreInfoSections/AdditionalInformation/AdditionalInformation';
import { CancellationPolicy } from 'component/page/detail/MoreInfoSections/CancellationPolicy/CancellationPolicy';
import FAQSection from 'component/page/detail/FAQSection/FAQSection';
import ReviewSection from 'component/page/detail/Review/ReviewSection/ReviewSection';
import { Tab } from 'component/page/detail/DetailPageTabs/DetailPageTabs.selectors';
import AboutActivity from 'component/page/detail/MoreInfoSections/AboutActivity/AboutActivity';

export interface TabSectionComponentProps extends DetailContentOnToggleProps {
    tab: Tab;
}

const TabSectionComponentMap: Record<NavigationHashEnum, React.FC<DetailContentOnToggleProps> | null> = {
    [NavigationHashEnum.OverviewSection]: ActivityOverview as React.FC<DetailContentOnToggleProps>, // ActivityOverview does not support toggle
    [NavigationHashEnum.PackageOptionsSection]: PackageOptionsWrapper as React.FC<DetailContentOnToggleProps>, // PackageOptionsWrapper does not support toggle
    [NavigationHashEnum.SimCardSpecSection]: SimCardSpecification,
    [NavigationHashEnum.IntroductionSummarySection]: IntroductionSummary,
    [NavigationHashEnum.DepartureReturnSection]: DepartureAndReturn,
    [NavigationHashEnum.WhatToExpectSection]: WhatToExpect,
    [NavigationHashEnum.LocationSection]: Location,
    [NavigationHashEnum.SuggestedRouteSection]: SuggestedRoute,
    [NavigationHashEnum.AdditionalInfoSection]: AdditionalInformation,
    [NavigationHashEnum.CancellationPolicySection]: CancellationPolicy,
    [NavigationHashEnum.FAQsSection]: FAQSection,
    [NavigationHashEnum.ReviewSection]: ReviewSection,
    [NavigationHashEnum.WhatsIncludedSection]: null,
    [NavigationHashEnum.EmbeddedSsrSection]: null,
    [NavigationHashEnum.AboutActivitySection]: AboutActivity,
};

export const DetailsSectionTab: React.FC<TabSectionComponentProps> = (props) => {
    const MappedComponent = TabSectionComponentMap[props.tab.id];
    if (!MappedComponent) return null;
    return <MappedComponent href={props.tab.href} onToggle={props.onToggle} isScrolling={props.isScrolling} />;
};

DetailsSectionTab.displayName = 'DetailsSectionTab';
